import { Upload, UploadFile, Image, Button, message, UploadProps, Space, Form } from "antd"
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { LineOutlined, PlusOutlined, QuestionCircleOutlined, StarOutlined, DownloadOutlined } from '@ant-design/icons';
import Server from "../../server/Server";
import EUtils from "../../utils/EUtils";
import URL from "../../server/URL";

interface IEAttachment {
    label?: string | null,
    name?: string | null,
    viewMode: number,
    multiple?: boolean
    attachment?: any,
    formRef: any,
    required?: boolean,
    onChanged?: (value: any) => void
}

const EAttachment = forwardRef((props: IEAttachment, ref: any) => {
    const { label, name, formRef, viewMode, attachment, required, onChanged } = props;

    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [fileInfo, setFileInfo] = useState<any>(null);

    useImperativeHandle(ref, () => ({
        getData: () => {
            return fileInfo ? JSON.stringify(fileInfo) : null;
        },
        setData: (value: any) => {
            if (value) {
                setFileInfo(value)
                setFileList([{
                    uid: value.fileID,
                    url: value.filePath,
                    name: value.orgName,
                    status: 'done',
                    thumbUrl: value.filePath
                }])
                formRef.current?.setFieldValue(name ?? 'attachment', value);
            } else {
                setFileInfo(null);
                setFileList([]);
                formRef.current?.setFieldValue(name ?? 'attachment', null);
            }
        }
    }));

    useEffect(() => {
        if (attachment) {
            setFileInfo(attachment)
            setFileList([{
                uid: attachment.FileID,
                url: attachment.FilePath,
                name: attachment.OrgName,
                status: 'done',
                thumbUrl: attachment.FilePath
            }])
            formRef.current?.setFieldValue(name ?? 'attachment', attachment);

        } else {
            setFileInfo(null);
            setFileList([]);
        }
    }, [attachment])

    useEffect(() => {
        if (onChanged) {
            onChanged(fileInfo);
        }
    }, [fileInfo])


    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as any);
        }
        // if (attachment.ExtentionName != '.jpg' && attachment.ExtentionName != '.png'
        //     && attachment.ExtentionName != '.gif' && attachment.ExtentionName != '.bmp'
        //     && attachment.ExtentionName != '.tif' && attachment.ExtentionName != '.tiff'
        //     && attachment.ExtentionName != '.svg' && attachment.ExtentionName != '.webp'
        //     && attachment.ExtentionName != '.ico') {
        //     message.warning('非图片文件不支持预览,请下载后查看');
        //     return;
        // }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
    };

    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    const getBase64 = (file: any): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const onChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        newFileList.map((i: any) => {
            i.status = 'done';
        })
        setFileList(newFileList);
    };
    const beforeUpload = (file: any) => {
        if (file) {
            const formData = new FormData();
            formData.append('file', file);
            // 发送请求
            Server.UpLoad(URL.Common.UpLoadFile, formData)
                .then((response: any) => {
                    if (response && response.data && response.data.isSuccess) {
                        setFileInfo(response.data?.fileInfo)
                    } else {
                        message.error('文件上传失败');
                        setFileList([]);
                    }
                })
        } else {
            setFileList([]);
        }
        return false; // Prevent default upload behavior
    };

    const handleDownload = (file: any) => {
        var request = {
            fileInfo: JSON.stringify(fileInfo),
        };
        var orgName = fileInfo.OrgName ?? fileInfo.orgName;
        Server.DownLoad(URL.Common.HttpDownLoadFile, request)
            .then((response: any) => {
                EUtils.DownLoadFile(response.data, orgName);
            })
    };

    const config: UploadProps = {
        maxCount: 12,
        onChange: onChange,
        beforeUpload: beforeUpload,
        onPreview: handlePreview,
        onDownload: handleDownload,
        onRemove: (file: any) => {
            formRef.current?.setFieldValue(name ?? 'attachment', null);
            setFileList([]);
            setFileInfo(null);
        },
        fileList: fileList,
        listType: 'picture',
        showUploadList: {
            // extra: ({ size = 0 }) => (
            //     <span style={{ color: '#cccccc' }}>({(size / 1024 / 1024).toFixed(2)}MB)</span>
            // ),
            showPreviewIcon: true,
            previewIcon: '预览',
            showDownloadIcon: true,
            downloadIcon: '下载',
            showRemoveIcon: viewMode != 2,
            removeIcon: <a style={{color:'red'}}>删除</a>,
        }
    }
    return <div>
        <Form.Item label={label ?? "附件"} name={name ?? "attachment"} rules={[{ required: required ?? false, message: '请上传附件' }]} style={{ marginBottom: '5px' }}>
            <Upload {...config} style={{ width: '100%' }}>
                {viewMode != 2 && fileList && fileList?.length < 1 ? <Button style={{ width: '100px' }}>上传附件</Button> : ''}
            </Upload>
        </Form.Item>
        {previewImage && (
            <Image
                wrapperStyle={{ display: 'none' }}
                preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible: any) => setPreviewOpen(visible),
                    // afterOpenChange: (visible:any) => !visible && setPreviewImage(''),
                }}
                src={previewImage}
            />
        )}
    </div>
})
export default EAttachment;